import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchReferenceData } from "../Features/ReferenceDataSlice.js";
import ConfigService from "../Services/ConfigService.js";
import { DEFAULT_TIME_ZONE, GTM_ID } from "../Constants/CommonConstants.js";
import TagManager from "react-gtm-module";
import GTMWrapper from "./Common/NoMatchFoundModal/GTMWrapper.jsx";
import { Settings } from "luxon";
import { manageApiResponseSelector } from "../Selectors/ApiResponseSelector.js";
import AppRoutes from "./Application/AppRoutes.jsx";
import {
  SLICE_REFERENCE_DATA,
  THUNK_GET_REFERENCE_DATA,
} from "../Constants/SliceAndThunkConstants.js";

const tagManagerArgs = { gtmId: ConfigService(GTM_ID) };
TagManager.initialize(tagManagerArgs);

/**
 * Sets the default time zone for Luxon
 */
Settings.defaultZone = DEFAULT_TIME_ZONE;

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchReferenceData());
  }, [dispatch]);

  const { apiResponses } = useSelector((state) =>
    manageApiResponseSelector(
      state,
      SLICE_REFERENCE_DATA,
      THUNK_GET_REFERENCE_DATA
    )
  );
  const { isSuccess } = apiResponses;
  return (
    <Fragment>
      {isSuccess ? (
        <>
          <GTMWrapper />
          <AppRoutes />
        </>
      ) : null}
    </Fragment>
  );
}

export default App;
